import { useState } from "react";
import { SettingsSlider } from "../Slider/Slider";

const PromptWeight = ({ style, dictionary, changeSettings, isLoading, isAdaptive }) => {
	const [value, setValue] = useState(7.5);

	const changeValue = (value) => {
		setValue(value);
		changeSettings(value, "prompt_strength");
	};

	return (
		<div className={style["settings-default-item"]}>
			<p className={style[`title`]}>
				{dictionary["prompt_weight"] || "Prompt weight"}
				<span id="weight-value" className={style[`slider_value`]}>
					{value}
				</span>
			</p>
			<SettingsSlider id={"prompt-weight"} value={value} onChange={changeValue} step={0.5} min={1} max={10} isAdaptive={isAdaptive} />
		</div>
	);
};

export default PromptWeight;
